import axiosInstance from "@/api/axios-instance";

export type UserSegment = "ACTIVE" | "INACTIVE" | "LAPSED" | "CHURNED";

export type UserExportStatus =
  | "PENDING"
  | "RUNNING"
  | "READY"
  | "FAILED"
  | "EXPIRED";

export interface SegmentCounts {
  ACTIVE: number;
  INACTIVE: number;
  LAPSED: number;
  CHURNED: number;
  TOTAL: number;
}

export interface UserExport {
  id: string;
  status: UserExportStatus;
  segments: UserSegment[];
  row_count: number | null;
  file_url: string | null;
  expires_at: string | null;
  started_at: string | null;
  completed_at: string | null;
  error: string | null;
  created_at: string;
  updated_at: string;
}

export async function previewUserExport(): Promise<SegmentCounts> {
  const res = await axiosInstance.post<SegmentCounts>("/user-exports/preview");
  return res.data;
}

export async function createUserExport(
  segments: UserSegment[],
): Promise<UserExport> {
  const res = await axiosInstance.post<UserExport>("/user-exports", {
    segments,
  });
  return res.data;
}

export async function listUserExports(): Promise<UserExport[]> {
  const res = await axiosInstance.get<UserExport[]>("/user-exports");
  return res.data;
}

export async function getUserExport(id: string): Promise<UserExport> {
  const res = await axiosInstance.get<UserExport>(`/user-exports/${id}`);
  return res.data;
}

export async function downloadUserExport(id: string): Promise<void> {
  const res = await axiosInstance.get(`/user-exports/${id}/download`, {
    responseType: "blob",
  });
  const url = URL.createObjectURL(res.data as Blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `users-export-${id}.csv`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
